/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PolicyRiskResponseDto = {
    /**
     * Policy risk UUID
     */
    id: string;
    /**
     * Risk type
     */
    type: PolicyRiskResponseDto.type;
    /**
     * Risk description
     */
    description: string;
    /**
     * Sum insured
     */
    sumInsured: number;
    /**
     * Excess
     */
    excess: number;
    /**
     * Address
     */
    address?: string | null;
    /**
     * Ando offering (insurance type)
     */
    offering?: string | null;
    /**
     * Ando risk key
     */
    andoRiskKey?: number | null;
    /**
     * Ando risk status
     */
    andoRiskStatus?: string | null;
    /**
     * Ando referral details payload
     */
    andoReferralDetails?: Record<string, any> | null;
    /**
     * Snapshot of Ando referral reasons captured when referral was first triggered
     */
    andoReferralReasonsSnapshot?: Record<string, any> | null;
    /**
     * Original Ando referral task ID
     */
    andoOriginalReferralTaskId?: string | null;
    /**
     * Specific details stored as JSONB
     */
    specificDetails?: Record<string, any>;
    /**
     * Original frontend risk details
     */
    originalFrontendRiskDetails?: Record<string, any> | null;
    /**
     * Commission % Ando quoted for the risk (agent_comm), e.g. 20 for 20%. Null when the policy's Ando data has none.
     */
    agentCommissionPercent?: number | null;
    /**
     * Created timestamp
     */
    createdAt: string;
    /**
     * Updated timestamp
     */
    updatedAt: string;
};
export namespace PolicyRiskResponseDto {
    /**
     * Risk type
     */
    export enum type {
        HOUSE = 'HOUSE',
        CONTENTS = 'CONTENTS',
        VEHICLE = 'VEHICLE',
    }
}

